"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tableRowClassName: function() {
        return tableRowClassName;
    },
    tableRowClassNames: function() {
        return tableRowClassNames;
    },
    useTableRowStyles_unstable: function() {
        return useTableRowStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tableRowClassName = 'fui-TableRow';
const tableRowClassNames = {
    root: tableRowClassName
};
const useTableLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f1u0rzck"
    }
}, {
    d: [
        ".f1u0rzck{display:table-row;}"
    ]
});
const useFlexLayoutStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59"
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}"
    ]
});
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        sj55zd: "f19n0e5",
        B7ck84d: "f1ewtqcl",
        Bconypa: "f1jazu75",
        B6guboy: "f1xeqee6",
        Bn4voq9: "fz36nt7",
        g9k6zt: "f9znhxp",
        Bfpq7zp: "fqrak0z",
        kdpuga: [
            "f1o2ludy",
            "f1kjnpwc"
        ],
        Bw81rd7: [
            "f1kjnpwc",
            "f1o2ludy"
        ],
        B6xbmo0: [
            "fxmnebo",
            "f1witrsb"
        ],
        dm238s: [
            "f1witrsb",
            "fxmnebo"
        ]
    },
    rootInteractive: {
        ecr2s2: "f1wfn5kd",
        lj723h: "f1g4hkjv",
        B43xm9u: "f15ngxrw",
        i921ia: "fjbbrdp",
        Jwef8y: "f1t94bn6",
        Bi91k9c: "feu1g3u",
        Bpt6rm4: "f1uorfem",
        ff6mpl: "fw60kww",
        ze5xyy: "f4xjyn1",
        pgvf35: "ff1wgvm",
        Bh7lczh: [
            "fiob0tu",
            "f1x4h75k"
        ],
        dpv3f4: "f1j6scgf",
        Bpnjhaq: [
            "f1x4h75k",
            "fiob0tu"
        ]
    },
    medium: {
        Bn0qgzm: "f1vxd6vx",
        oivjwe: "fg706s2",
        B9xav0g: "frpde29"
    },
    small: {
        Bn0qgzm: "f1vxd6vx",
        oivjwe: "fg706s2",
        B9xav0g: "frpde29"
    },
    "extra-small": {
        Be2twd7: "fy9rknc"
    },
    brand: {
        De3pzq: "f16xkysk",
        g2u3we: "f1bh3yvw",
        h3c5rm: [
            "fmi79ni",
            "f11fozsx"
        ],
        B9xav0g: "fnzw4c6",
        zhjwy3: [
            "f11fozsx",
            "fmi79ni"
        ],
        ecr2s2: "f7tkmfy",
        lj723h: "f1r2dosr",
        gwxt9v: "fqlf3fd",
        v3aym: [
            "f9dpb3h",
            "fw2muls"
        ],
        Bc736ss: "f1yat0gj",
        Bk6ri7n: [
            "fw2muls",
            "f9dpb3h"
        ],
        Bk5ld8o: "f7nae3y",
        c4eypz: [
            "fkbere7",
            "fa97sf3"
        ],
        felo30: "fmtyzcc",
        Eshu5l: [
            "fa97sf3",
            "fkbere7"
        ],
        Bjwas2f: "fb6zhgp",
        Bn1d65q: [
            "fyowp6c",
            "fz08sq8"
        ],
        Bxeuatn: "f9dii88",
        n51gp8: [
            "fz08sq8",
            "fyowp6c"
        ],
        Beo2b4z: [
            "f1afxoft",
            "flqq2yx"
        ],
        h6lo6r: [
            "flqq2yx",
            "f1afxoft"
        ],
        Btyw6ap: [
            "f1b5xrmd",
            "f1831rx6"
        ],
        w1pwid: [
            "f1831rx6",
            "f1b5xrmd"
        ],
        Brwvgy3: "fd94n53",
        yadkgm: "f1e0wld5"
    },
    neutral: {
        gwxt9v: "fqlf3fd",
        v3aym: [
            "f9dpb3h",
            "fw2muls"
        ],
        Bc736ss: "f1yat0gj",
        Bk6ri7n: [
            "fw2muls",
            "f9dpb3h"
        ],
        Bk5ld8o: "f7nae3y",
        c4eypz: [
            "fkbere7",
            "fa97sf3"
        ],
        felo30: "fmtyzcc",
        Eshu5l: [
            "fa97sf3",
            "fkbere7"
        ],
        Bjwas2f: "fb6zhgp",
        Bn1d65q: [
            "fyowp6c",
            "fz08sq8"
        ],
        Bxeuatn: "f9dii88",
        n51gp8: [
            "fz08sq8",
            "fyowp6c"
        ],
        Beo2b4z: [
            "f1afxoft",
            "flqq2yx"
        ],
        h6lo6r: [
            "flqq2yx",
            "f1afxoft"
        ],
        Btyw6ap: [
            "f1b5xrmd",
            "f1831rx6"
        ],
        w1pwid: [
            "f1831rx6",
            "f1b5xrmd"
        ],
        Brwvgy3: "fd94n53",
        yadkgm: "f1e0wld5",
        De3pzq: "fq5gl1p",
        sj55zd: "f1cgsbmv",
        Jwef8y: "f1uqaxdt",
        ecr2s2: "fa9o754",
        g2u3we: "frmsihh",
        h3c5rm: [
            "frttxa5",
            "f11o2r7f"
        ],
        B9xav0g: "fem5et0",
        zhjwy3: [
            "f11o2r7f",
            "frttxa5"
        ]
    },
    none: {}
}, {
    d: [
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".f1jazu75[data-fui-focus-within]:focus-within .fui-TableSelectionCell{opacity:1;}",
        ".f1xeqee6[data-fui-focus-within]:focus-within .fui-TableCellActions{opacity:1;}",
        ".fz36nt7[data-fui-focus-visible]{outline-width:2px;}",
        ".f9znhxp[data-fui-focus-visible]{outline-style:solid;}",
        ".fqrak0z[data-fui-focus-visible]{outline-color:var(--colorStrokeFocus2);}",
        ".f1o2ludy[data-fui-focus-visible]{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f1kjnpwc[data-fui-focus-visible]{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".fxmnebo[data-fui-focus-visible]{border-top-right-radius:var(--borderRadiusMedium);}",
        ".f1witrsb[data-fui-focus-visible]{border-top-left-radius:var(--borderRadiusMedium);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        ".fg706s2{border-bottom-style:solid;}",
        ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".f16xkysk{background-color:var(--colorBrandBackground2);}",
        ".f1bh3yvw{border-top-color:var(--colorTransparentStrokeInteractive);}",
        ".fmi79ni{border-right-color:var(--colorTransparentStrokeInteractive);}",
        ".f11fozsx{border-left-color:var(--colorTransparentStrokeInteractive);}",
        ".fnzw4c6{border-bottom-color:var(--colorTransparentStrokeInteractive);}",
        ".fq5gl1p{background-color:var(--colorSubtleBackgroundSelected);}",
        ".f1cgsbmv{color:var(--colorNeutralForeground1Hover);}",
        ".frmsihh{border-top-color:var(--colorNeutralStrokeOnBrand);}",
        ".frttxa5{border-right-color:var(--colorNeutralStrokeOnBrand);}",
        ".f11o2r7f{border-left-color:var(--colorNeutralStrokeOnBrand);}",
        ".fem5et0{border-bottom-color:var(--colorNeutralStrokeOnBrand);}"
    ],
    a: [
        ".f1wfn5kd:active{background-color:var(--colorSubtleBackgroundPressed);}",
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".f15ngxrw:active .fui-TableCellActions{opacity:1;}",
        ".fjbbrdp:active .fui-TableSelectionCell{opacity:1;}",
        ".f7tkmfy:active{background-color:var(--colorBrandBackground2);}",
        ".f1r2dosr:active{color:var(--colorNeutralForeground1);}",
        ".fa9o754:active{background-color:var(--colorSubtleBackgroundSelected);}"
    ],
    h: [
        ".f1t94bn6:hover{background-color:var(--colorSubtleBackgroundHover);}",
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1uorfem:hover .fui-TableCellActions{opacity:1;}",
        ".fw60kww:hover .fui-TableSelectionCell{opacity:1;}",
        ".f1uqaxdt:hover{background-color:var(--colorSubtleBackgroundSelected);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f4xjyn1:hover{color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.ff1wgvm:hover{border-top-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1x4h75k:hover{border-left-color:Highlight;}.fiob0tu:hover{border-right-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1j6scgf:hover{border-bottom-color:Highlight;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fqlf3fd{border-top-width:2px;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9dpb3h{border-right-width:2px;}.fw2muls{border-left-width:2px;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1yat0gj{border-bottom-width:2px;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f7nae3y{border-top-style:solid;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fa97sf3{border-left-style:solid;}.fkbere7{border-right-style:solid;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fmtyzcc{border-bottom-style:solid;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fb6zhgp{border-top-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fyowp6c{border-right-color:transparent;}.fz08sq8{border-left-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f9dii88{border-bottom-color:transparent;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1afxoft{border-bottom-right-radius:var(--borderRadiusMedium);}.flqq2yx{border-bottom-left-radius:var(--borderRadiusMedium);}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1831rx6{border-top-left-radius:var(--borderRadiusMedium);}.f1b5xrmd{border-top-right-radius:var(--borderRadiusMedium);}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fd94n53{box-sizing:border-box;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1e0wld5:focus-visible{outline-offset:-4px;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useTableRowStyles_unstable = (state)=>{
    const styles = useStyles();
    const layoutStyles = {
        table: useTableLayoutStyles(),
        flex: useFlexLayoutStyles()
    };
    state.root.className = (0, _react.mergeClasses)(tableRowClassNames.root, styles.root, !state.isHeaderRow && styles.rootInteractive, styles[state.size], state.noNativeElements ? layoutStyles.flex.root : layoutStyles.table.root, styles[state.appearance], state.root.className);
    return state;
}; //# sourceMappingURL=useTableRowStyles.styles.js.map
